import actions from './actions'
import getters from './getters'
import mutations from './mutations'

const defaultState = {
  initData: {
    shopSeq: null,
    shopId: '',
    name: '',
    categoryList: [],
    count: 0,
    enableReward: false,
    rewardValue: 0,
    maxRewardPerMonth: 0,
    paymentSystemType: 1,
    enableCart: true,
    gameName: '',
    startDateTime: '', // 점검 시작 시간
    endDateTime: '', // 점검 종료 시간
    message: '' // 점검 메시지
  },
  homeData: {
    promotionList: [],
    collectionList: [],
    newList: []
  },
  control: {
    collectionList: {}, // size, limit, length, isMore
    newList: {} // size, limit, length, isMore
  },
  category: {
    page: 0,
    pageSize: 20,
    productList: [],
    last: false
  },
  tag: {
    // tagList에서 사용
    page: 0,
    pageSize: 20,
    productList: [],
    last: false
  },
  requestPossible: true
}

export default {
  namespaced: true,
  state: defaultState,
  actions,
  getters,
  mutations
}
